import { z } from 'zod'
import { AccountStatusIdSchema, idSchemaV2, isId } from '../ids'
import { AuditPropsSchema } from '../common'
import { ArchivableSchema } from '../archive'

const SitOutcomeFilterSchema = z.enum(['before', 'after'])
export type SitOutcomeFilter = z.infer<typeof SitOutcomeFilterSchema>

export const SitOutcomeFaultSchema = z.enum(['setter', 'closer'])
export type SitOutcomeFault = z.infer<typeof SitOutcomeFaultSchema>

export const EventDateTypeSchema = z.enum(['eventDate', 'createdAt'])
export type EventDateType = z.infer<typeof EventDateTypeSchema>

export const UnsavedEventOutcomeSchema = z
  .object({
    name: z.string(),
    order: z.number().optional(),
    occurred: z.boolean().optional(),
    reschedule: z.boolean().optional(),
    closed: z.boolean().optional(),
    /**
     * Before: appears only before the eventDate
     * After: appears only after the eventDate
     * Undefined: always appears
     */
    show: SitOutcomeFilterSchema.nullable().optional(),
    /**
     * setter/closer responsible for this outcome
     */
    fault: SitOutcomeFaultSchema.optional(),
    color: z.string().optional(),
    fromAccountStatusId: AccountStatusIdSchema.optional(),
    accountStatusId: AccountStatusIdSchema.optional(),
    eventDateType: EventDateTypeSchema.optional(),
    integrationMapping: z.array(z.string()).optional().meta({
      description: 'Integration mapping for the event outcome',
    }),
  })
  .meta({ deprecated: true })
export type UnsavedEventOutcome = z.infer<typeof UnsavedEventOutcomeSchema>

export const EventOutcomeIdSchema = idSchemaV2('O').meta({ deprecated: true })
export type EventOutcomeId = z.infer<typeof EventOutcomeIdSchema>
export const isEventOutcomeId = isId(EventOutcomeIdSchema)

export type WithEventOutcomeId = {
  outcomeId: EventOutcomeId
}

export const EventOutcomeDataSchema = z.object({
  ...ArchivableSchema.shape,
  ...AuditPropsSchema.shape,
  ...UnsavedEventOutcomeSchema.shape,
  outcomeId: EventOutcomeIdSchema,
})
export type EventOutcomeData = z.infer<typeof EventOutcomeDataSchema>
